import { HStack, VStack } from "@gluestack-ui/themed";
import { CompleteRegistrationAccordionProps } from "./types";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";
import { InfoSection } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection";
import { GenderEnum, MartialStatusEnum } from "@repo/core/enums/proposals";
import { martialStatusByValue } from "@repo/core/constants/proposals";

export const CompleteRegistrationAccordion = ({
  cpf,
  name,
  phone,
  birthday,
  gender,
  martialStatus,
  profession,
  ...rest
}: CompleteRegistrationAccordionProps) => {
  const martialStatusLabel =
    martialStatusByValue[martialStatus as MartialStatusEnum];
  return (
    <AccordionContainer {...rest}>
      <InfoSection title="CPF" value={cpf} />
      <InfoSection title="Cliente" value={name} />
      <InfoSection title="Celular" value={phone} />
      <InfoSection title="Data de Nascimento" value={birthday} />
      <HStack flex={1} justifyContent="space-between">
        <VStack flex={1}>
          <InfoSection
            title="Gênero"
            value={gender === GenderEnum.MALE ? "Masculino" : "Feminino"}
          />
        </VStack>
        <VStack flex={1}>
          <InfoSection title="Estado Civil" value={martialStatusLabel} />
        </VStack>
      </HStack>
      <InfoSection title="Profissão" value={profession} />
    </AccordionContainer>
  );
};
